import { Grid, Paper } from '@material-ui/core';
import { Button, ExtendedTheme, Heading, TextBlock } from 'neon-design-system';
import { createStyles, makeStyles } from '@material-ui/styles';

interface Props {
  title: string;
  subtitle: string;
  buttonText: string;
  onClick: () => void;
}

const useStyles = makeStyles((theme: ExtendedTheme) =>
  createStyles({
    noRequestsPaper: {
      padding: theme.spacing(2)
    }
  })
);

export const RequestsListTile = ({ title, subtitle, buttonText, onClick }: Props) => {
  const classes = useStyles();
  return (
    <Paper className={classes.noRequestsPaper}>
      <Grid container spacing={2}>
        <Grid item xs={12}>
          <Grid container spacing={1}>
            <Grid item xs={12}>
              <Heading styleName="title1">{title}</Heading>
            </Grid>
            <Grid item xs={12}>
              <TextBlock styleName="footnote">{subtitle}</TextBlock>
            </Grid>
          </Grid>
        </Grid>
        <Grid item xs={12}>
          <Button colorType="grey" onClick={onClick}>
            {buttonText}
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};
